const dev = {
  API_EXTERNAL_TRADE_ENDPOINT_URL: "https://www.capmas.gov.eg:8090",
  API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  // API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  SEARCH_API_ENDPOINT_URL: "https://www.capmas.gov.eg:8087",
  // SEARCH_API_ENDPOINT_URL: "http://10.10.80.21:8087",
  // SEARCH_API_ENDPOINT_URL: "https://localhost:44309",
  // SEARCH_API_ENDPOINT_URL: "https://searchapi-capmas-test.mped.gov.eg",
  // SEARCH_API_ENDPOINT_URL: "https://searchapi.capmas-test.mped.gov.eg",
  API_POPULATION_ENDPOINT_URL:
    "https://europe-west1-menusmaker.cloudfunctions.net",
  API_LIVE_POPULATION_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
};

const prod = {
  API_EXTERNAL_TRADE_ENDPOINT_URL: "https://www.capmas.gov.eg:8090",
  API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  // API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  SEARCH_API_ENDPOINT_URL: "https://www.capmas.gov.eg:8087",
  API_POPULATION_ENDPOINT_URL:
    "https://europe-west1-menusmaker.cloudfunctions.net",
  API_LIVE_POPULATION_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
};

const test = {
  API_EXTERNAL_TRADE_ENDPOINT_URL: "https://www.capmas.gov.eg:8090",
  API_ENDPOINT_URL: "https://www.capmas.gov.eg:8080",
  // API_ENDPOINT_URL: "https://capmas-api.digitalhub.com.eg",
  SEARCH_API_ENDPOINT_URL: "https://www.capmas.gov.eg:8087",
  API_POPULATION_ENDPOINT_URL:
    "https://europe-west1-menusmaker.cloudfunctions.net",
  API_LIVE_POPULATION_ENDPOINT_URL: "https://www.capmas.gov.eg:8080/population-proxy",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
